import { METHODS, request } from '../axiosInstances';

export default {
  login: (params = {}) => request(METHODS.POST, 'login/', { params }),
  info: () => request(METHODS.GET, '/user/info/', {}),
};
